var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mx-2 mt-4"},[_c('i',{class:_vm.social.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }